import React from "react";
import { motion, Variants } from "framer-motion";
import haystack from "../../images/haymonum.jpg";

// Animation factory
const fadeUp = (delay: number = 0): Variants => ({
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { delay, duration: 0.8, ease: "easeInOut" },
    },
});

const HayStory = () => {
    return (
        <section aria-labelledby="haystory-title" className="bg-white pt-16 pb-14 text-[#0a0a0a] md:pt-[92px] min-h-screen">
            {/* Title */}
            <div className="grid grid-cols-[1fr_minmax(0,800px)_1fr] items-stretch border-b border-[#d9d9d9]">
                <div aria-hidden="true" className="bg-[#d9d9d9]" />
                <motion.h2
                    id="haystory-title"
                    className="px-6 py-2 text-center text-[22px] font-normal leading-[1.2] sm:text-[30px] lg:text-[50px]"
                    style={{ fontFamily: '"Monument Extended", "ClashDisplay-Medium", sans-serif' }}
                    variants={fadeUp(0.2)}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    The Haystack Story
                </motion.h2>
                <div aria-hidden="true" className="bg-[#d9d9d9]" />
            </div>

            {/* Content */}
            <div className="mx-auto mt-10 grid grid-cols-1 items-start gap-8 px-8 sm:px-16 md:mt-14 md:px-24 md:gap-20 lg:grid-cols-[1.23fr_1fr] lg:px-36">
                <motion.p
                    className="font-inter text-base font-light leading-7 text-justify sm:text-lg sm:leading-8 lg:text-xl lg:leading-10"
                    variants={fadeUp(0.3)}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    In 1806, five students of Williams College, Massachusetts took shelter
                    from a storm under a farmer&apos;s haystack to continue a meeting. It
                    was under this haystack that these young men began to share a passion
                    to reach foreign countries with the Gospel of Jesus. This was how an
                    inconvenient situation became the birthplace of one of the greatest
                    missionary movements of the Century. On that spot today stands the
                    famous Haystack Monument as a memorial of that historic event inscribed
                    with the words, &quot;The Field is the World.&quot;
                </motion.p>

                <motion.div
                    className="w-full"
                    variants={fadeUp(0.4)}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    <img src={haystack} alt="Haystack Monument" className="aspect-[333/261] w-full rounded-[14px] object-cover" loading="lazy" />
                </motion.div>
            </div>

        </section>
    );
};

export default HayStory;
